import React from 'react';

import { useIntl } from 'react-intl';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import { ToggleFilter } from '../../../../../common/ui/filters/toggle-filter';
import { useBooleanFilter } from '../../../../../controllers/filters/boolean-filter';
import { usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { filter as archivedAndPendingComponentsFilter } from '../../../../../controllers/store/search/filters/archived-and-pending-components';

import { i18n } from './messages';

const ArchivedAndPendingComponentsFilter = ({
	isFilterInDropdown = false,
	showPrimaryProductIcon,
	onFilterChange,
	fit,
}: FilterProps): React.JSX.Element | null => {
	const [primaryProduct] = usePrimaryProduct();
	const { formatMessage } = useIntl();
	const [state, { toggle }] = useBooleanFilter({
		filterId: archivedAndPendingComponentsFilter.id,
	});

	if (!state) {
		return null;
	}

	const { value, autoFocus } = state;

	return (
		<ToggleFilter
			onChange={() => {
				onFilterChange?.({ isSelected: value });
				toggle();
			}}
			isChecked={value}
			autoFocus={autoFocus}
			isFilterInDropdown={isFilterInDropdown}
			iconBefore={
				<FilterProductIcon
					primaryProduct={primaryProduct}
					showPrimaryProductIcon={showPrimaryProductIcon}
				/>
			}
		>
			{formatMessage(i18n.archivedAndPendingComponents)}
		</ToggleFilter>
	);
};

export default ArchivedAndPendingComponentsFilter;
